import de from "./de";
import en from "./en";
import es from "./es";
import fr from "./fr";
import it from "./it";
import ja from "./ja";
import ko from "./ko";
import nl from "./nl";
import tr from "./tr";

const displayTexts = {
  en,
  es,
  de,
  fr,
  it,
  ja,
  ko,
  nl,
  tr,
};

export default displayTexts;
